import TumengPriceTag from './src/index.vue'

TumengPriceTag.install = function(Vue) {
  Vue.component(TumengPriceTag.name, TumengPriceTag)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengPriceTag)
}

export default TumengPriceTag
